<template>
  <component
    :is="'router-link'"
    class="asset-block"
    :class="{ 'sound' : type === 'sound_assets' }"
    :to="{name: 'ProductView', params: {product: product.Slug}}">
    <div class="asset-content">
      <div
        class="preview"
        :class="{
                'big' : !subtitle || subtitle === '',
                'design' : type === 'design_assets',
        }">
        <img
          v-lazy="previewSrc()"
          :class="{ 'contain': (preview && type === 'design_assets') }"
          alt=""/>
        <div v-if="type === 'sound_assets'" class="preview-sound"
             @click.stop.prevent="playAudio()">
          <div class="play-sound" v-if="!audioLoading && !audioPlaying">
            <img src="@/assets/images/icons/Play_vignette_icon.svg"
                 :alt="title + '_preview_button'"/>
          </div>
          <div :class="{ 'd-none' : !audioLoading && !audioPlaying }"
               class="audio-player">
            <vue-plyr :options="videoOptions" ref="plyr">
              <audio id="player-{{this.id}}"
                     class="w-100" :src="audioSource"></audio>
            </vue-plyr>
          </div>
        </div>
        <div class="badges">
          <div v-if="mainfilter && mainfilter !== ''" class="badge">
            {{ mainfilter }}
          </div>
          <div v-if="isRecent()" class="badge recent">
            {{ t('label.recent') }}
          </div>
        </div>
        <div class="meta">
          <p v-if="type === 'sound_assets'">
            {{ meta.duration }}
          </p>
        </div>
      </div>
      <label v-if="title" class="title">{{ title }}</label>
      <label v-if="subtitle && subtitle !== ''" class="subtitle">{{ subtitle }}</label>
      <div class="actions">
        <div v-if="false && preview" class="action"
             @click.stop.prevent="$parent.displayPreview('image', preview, title)">
          <img src="@/assets/images/icons/Icon_Btn_Zoom.svg" :alt="title + '_preview_button'"/>
        </div>
        <div v-if="false && type === 'sound_assets'" class="action"
             @click.stop.prevent="!audioPlaying ? playAudio() : stopAudio()">
          <img v-if="!audioLoading && !audioPlaying"
               src="@/assets/images/icons/Icon_Btn_Audio_Play.svg"
               :alt="title + '_preview_button'"/>
          <img v-else-if="audioPlaying"
               src="@/assets/images/icons/Icon_Btn_Audio_Stop.svg"
               :alt="title + '_preview_button'"/>
          <img v-else
               src="@/assets/images/loading/loading-spin.svg"
               :alt="title + '_preview_button'"/>
        </div>
        <div class="action" @click.stop.prevent="downloadAsset()">
          <img v-if="!downloadLoading"
               src="@/assets/images/icons/Icon_Btn_Download.svg"
               :alt="title + '_download_button'"/>
          <img v-else
               src="@/assets/images/loading/loading-spin.svg"
               :alt="title + '_wait_button'"/>
          <span v-if="!downloadLoading && !isDownloaded">
              {{ t('label.download') }}
              </span>
          <span v-if="!downloadLoading && isDownloaded">
              {{ t('label.redownload') }}
          </span>
        </div>

      </div>
    </div>
  </component>
</template>

<script>

import {
  CHECK_AUTH, DOWNLOAD_PRODUCT,
  LOGIN,
} from '@/store/actions.type';
import store from '@/store';
import { saveUrlReferer } from '@/common/referer.service';
import { mapGetters } from 'vuex';
import { useI18n } from 'vue-i18n';

export default {
  name: 'AssetBlock',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  watch: {
    activePlayer() {
      if (this.activePlayer != null && this.activePlayer !== this.id) {
        this.stopAudio();
      }
    },
  },
  methods: {
    previewSrc() {
      let preview = '';
      if (this.type === 'graph_assets') {
        preview = this.preview ?? this.images('./Bg_Block_default.jpg');
      } else if (this.type === 'design_assets') {
        preview = this.preview ?? this.images('./Bg_Block_default.jpg');
      } else if (this.type === 'support_assets') {
        preview = this.preview ?? this.images('./Bg_Support.jpg');
      } else if (this.type === 'sound_assets') {
        switch (this.mainfilter) {
          case 'Effet':
          case 'Effect':
            preview = this.images('./Bg_Sound_FX.jpg');
            break;
          case 'Musique':
          case 'Music':
          default:
            preview = this.images('./Bg_Sound_Music.jpg');
            break;
          case 'Ambiance':
          case 'Athmosphere':
            preview = this.images('./Bg_Sound_Ambiance.jpg');
            break;
        }
      }
      return preview;
    },
    playAudio() {
      if (this.audioPlayer == null && this.$refs.plyr != null) {
        this.audioPlayer = this.$refs.plyr.player;
      }
      if (this.audioPlayer != null && !this.audioPlaying) {
        this.audioPlayer.currentTime = 0;
        this.audioLoading = true;
        // eslint-disable-next-line prefer-destructuring
        this.audioSource = this.product.Audios[0];
        if (this.canPlay) {
          this.audioPlayer.play();
        } else {
          this.audioPlayer.once('canplay', this.firstPlay);
        }
        this.audioPlaying = true;
        this.audioPlayer.on('ended', this.onStop);
        this.audioPlayer.on('play', this.onPlay);
        this.audioLoading = false;
      }
    },
    onPlay() {
      this.$emit('previewSound', { next: this.id });
    },
    onStop() {
      if (this.audioPlayer != null) {
        this.audioPlayer.currentTime = 0;
        this.audioPlaying = false;
        this.audioPlayer.off('ended', this.onStop);
        this.audioPlayer.off('play', this.onPlay);
        this.audioPlayer.off('canplay', this.firstPlay);
        this.$emit('previewSound', { src: 'preview', next: null });
      }
    },
    stopAudio() {
      if (this.audioPlayer != null) {
        this.audioPlaying = false;
        this.audioPlayer.pause();
      }
    },
    firstPlay() {
      if (!this.canPlay && this.audioPlayer != null) {
        this.canPlay = true;
        this.audioPlayer.play();
      }
    },
    async downloadAsset() {
      const { id, title } = this;
      const extension = this.fileName.split('.').pop();
      const fileName = `${title}.${extension}`;
      const lang = this.$i18n.locale;
      store.dispatch(CHECK_AUTH)
        .then(() => {
          if (this.currentUser) {
            this.downloadLoading = true;
            store.dispatch(DOWNLOAD_PRODUCT, { id, fileName, lang }).then(() => {
              this.downloadLoading = false;
              this.isDownloaded = true;
            });
          } else {
            this.$parent.$refs.confirmDialogue.show().then((result) => {
              if (result) {
                saveUrlReferer(this.$route.path);
                store.dispatch(LOGIN);
              }
            });
          }
        });
    },
    isRecent() {
      const currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() - 1);
      return this.date != null && new Date(this.date) > currentDate;
    },
  },
  data() {
    return {
      downloadLoading: false,
      isDownloaded: this.downloaded,
      audioLoading: false,
      audioPlaying: false,
      audioPlayer: null,
      audioSource: null,
      canPlay: false,
      videoOptions: {
        controls: ['play', 'progress'],
        settings: [],
      },
      images: require.context('@/assets/images/background/', false, /\.jpg$/),
    };
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    downloaded: {
      type: Boolean,
      default: false,
    },
    activePlayer: {
      type: String,
      default: null,
    },
    fileName: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    preview: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    mainfilter: {
      type: String,
      default: null,
    },
    meta: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style>
  .plyr__volume{
    min-width: 150px;
    max-width: 150px;
  }
  :root {
    --plyr-color-main: var(--primary);
    --plyr-range-track-height: 15px;
    --plyr-range-thumb-height: 20px;
    --plyr-audio-control-color: white;
    --plyr-audio-progress-buffered-background: white;
    --plyr-audio-controls-background: transparent;
  }
</style>
